import env from "@beam-australia/react-env"
import moment from "moment"
import { FC, useContext, useMemo, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { toast } from "react-toastify"
import { icons } from "src/assets"
import { PrivateLoader } from "src/components/templates"
import { Button, Checkbox, FormControlLabel, Grid, SelectInput, TextFieldLabel, Typography } from "src/components/UI"
import UploadDocuments from "src/components/UI/CustomUI/molecules/UploadDocument"
import { contractorsActions, filesActions, filtersActions } from "src/ducks/actions"
// import { getContractorsFilter } from "src/ducks/filters/selector"
// import { ContractorsFilterType } from "src/ducks/filters/types"
import { FILE_TYPE, isEmpty, ParseFilesUrl, PHONE_MASK_INPUT, PHONE_MASK_REGEXP, validateEmail } from "src/helpers"
import { ContractorsContext } from "../../context"
import { dispatchTypes, MODAL_TYPE } from "../../context/types"
import { getOnlyTerritoriesForDropdown } from "src/ducks/territories/selectors"
import { SelectInputOption } from "src/components/UI/CustomUI/atoms/SelectInput/types"
import { getAllContractors } from "src/ducks/contractors/selectors"
import { ContractorItem } from "src/ducks/types"

const FILES_URL = env('FILES_URL') ?? ''

const AddContractor: FC = () => {

    const dispatch = useDispatch()
    const { dispatch: dispatchContext } = useContext(ContractorsContext)
    const territories = useSelector(getOnlyTerritoriesForDropdown)
    const [addContractorTerritory, setAddContractorTerritory] = useState<{ key: string, label: string } | null>(null)


    const contractors = useSelector(getAllContractors)

    const contractorEmails = contractors.map(contractor => contractor.email)
    // const contractorsFilter = useSelector(getContractorsFilter())

    // const selectedAffiliates = useMemo(
    //     () => contractorsFilter.selectedAffiliates || [],
    //     [contractorsFilter]
    // )

    const [loading, setLoading] = useState(false)
    const [showWarnings, setShowWarnings] = useState(false)
    const [uploadingFile, setUploadingFile] = useState(false)
    const [file, setFile] = useState<any>(null)

    // FORM
    const [contractorName, setContractorName] = useState('')
    const [contractorFirstName, setContractorFirstName] = useState('')
    const [contractorLastName, setContractorLastName] = useState('')
    const [contractorEmail, setContractorEmail] = useState('')
    const [websiteUrl, setWebsiteUrl] = useState('')
    const [docuSignLink, setDocuSignLink] = useState('')
    const [active, setActive] = useState(false)

    const isEmailAlreadyExists = contractorEmails.includes(contractorEmail)

    const isValidUrl = (url: string) => {
        const urlPattern = new RegExp('^(https?:\\/\\/)?' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
        return !!urlPattern.test(url);
    }


    const validate = !isEmpty(contractorName) &&
        !isEmpty(contractorFirstName) &&
        !isEmpty(contractorLastName) &&
        !isEmpty(contractorEmail) &&
        validateEmail(contractorEmail) &&
        !isEmpty(websiteUrl) &&
        isValidUrl(websiteUrl) &&
        active !== undefined && active !== null &&
        !isEmailAlreadyExists

    // const updateContractorsFilter = (newFilter: Partial<ContractorsFilterType>) => {
    //     dispatch(
    //         filtersActions.setFilters({
    //             contractors: {
    //                 ...contractorsFilter,
    //                 ...newFilter,
    //             },
    //         })
    //     )
    // }


    const handleCancel = () => {
        dispatchContext({ type: dispatchTypes.SET_VALUE, payload: { attr: 'modalOpen', value: false } })
    }

    const handleCreate = () => {
        if (validate) {
            setLoading(true)
            const websiteUrlWithProtocol = websiteUrl.startsWith('http') ? websiteUrl : `https://${websiteUrl}`
            const docuSignLinkWithProtocol = docuSignLink ? docuSignLink.startsWith('http') ? docuSignLink : `https://${docuSignLink}` : ''
            const newContractor = {
                name: contractorName,
                firstName: contractorFirstName,
                lastName: contractorLastName,
                websiteUrl: websiteUrlWithProtocol,
                docuSignLink: docuSignLinkWithProtocol,
                // active: active,
                email: contractorEmail,
            }
            dispatch(contractorsActions.createContractor({ contractor: newContractor }, (succ, resContractor) => {
                if (succ) {
                    dispatchContext({ type: dispatchTypes.SET_VALUE, payload: { attr: 'modalOpen', value: false } })
                    if (resContractor) {
                        dispatch(contractorsActions.fetchAllContractors({ searchParams: { search: '' } }))
                    }
                    dispatch(contractorsActions.setContractor(resContractor as ContractorItem))
                    dispatchContext({
                        type: dispatchTypes.SET_VALUE,
                        payload: {
                            attr: 'modalType',
                            value: MODAL_TYPE.EDIT,
                        },
                    })
                    dispatchContext({
                        type: dispatchTypes.SET_VALUE,
                        payload: {
                            attr: 'modalOpen',
                            value: true,
                        },
                    })
                    toast.success.call('success', 'Contractor Created')
                    setLoading(false)
                    // if (addContractorTerritory?.key) {
                    //     setTimeout(() => {
                    //         dispatch(contractorsActions.setContractorTerritory({ contractorId: resContractor?.id as string, territoryId: addContractorTerritory?.key as string }, (succ) => {
                    //             if (succ) {
                    //                 toast.success.call('success', `Contractor assigned to ${addContractorTerritory?.label}`)
                    //                 setLoading(false)
                    //             } else {
                    //                 setLoading(false)
                    //             }
                    //             toast.success.call('success', 'Contractor Created')
                    //             dispatchContext({ type: dispatchTypes.SET_VALUE, payload: { attr: 'modalOpen', value: false } })
                    //             if (resContractor) {
                    //                 dispatch(contractorsActions.fetchAllContractors({ searchParams: { search: '' } }))
                    //             }
                    //         }))
                    //     }, 1000)
                    // } else {
                    //     dispatchContext({ type: dispatchTypes.SET_VALUE, payload: { attr: 'modalOpen', value: false } })
                    //     if (resContractor) {
                    //         dispatch(contractorsActions.fetchAllContractors({ searchParams: { search: '' } }))
                    //     }
                    //     toast.success.call('success', 'Contractor Created')
                    //     setLoading(false)
                    // }
                } else {
                    setLoading(false)
                }
            }))
        } else {
            setShowWarnings(true)
        }

    }

    const handleChangeTerritory = (newSelected: SelectInputOption) => {
        setAddContractorTerritory({ key: newSelected.key, label: newSelected.label })
    }


    return (
        <PrivateLoader loading={loading}>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <TextFieldLabel
                        labelVariant='body1Bold'
                        label='Contractor Name:'
                        placeholder='Contractor Name'
                        value={contractorName}
                        helperText={showWarnings && isEmpty(contractorName) ? 'Should add Contractor Name' : ''}
                        error={showWarnings && isEmpty(contractorName)}
                        onChange={(event) => setContractorName(event.target.value)}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextFieldLabel
                        labelVariant='body1Bold'
                        label='Contractor First Name:'
                        helperText={showWarnings && isEmpty(contractorFirstName) ? 'Should add Contractor First Name' : ''}
                        error={showWarnings && isEmpty(contractorFirstName)}
                        placeholder='Contractor First Name'
                        value={contractorFirstName}
                        onChange={(event) => setContractorFirstName(event.target.value)}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextFieldLabel
                        labelVariant='body1Bold'
                        label='Contractor Last Name:'
                        placeholder='Contractor Last Name'
                        value={contractorLastName}
                        helperText={showWarnings && isEmpty(contractorLastName) ? 'Should add Contractor Last Name' : ''}
                        error={showWarnings && isEmpty(contractorLastName)}
                        onChange={(event) => setContractorLastName(event.target.value)}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextFieldLabel
                        labelVariant='body1Bold'
                        type='email'
                        label='Contractor Email:'
                        placeholder='name@mail.com'
                        value={contractorEmail}
                        helperText={showWarnings && isEmpty(contractorEmail) || Boolean(contractorEmail && !validateEmail(contractorEmail)) ?
                            'Should add a valid Email' : isEmailAlreadyExists ? 'Email is already used, please use a different one' : ''}
                        error={showWarnings && isEmpty(contractorEmail) || Boolean(contractorEmail && !validateEmail(contractorEmail)) || isEmailAlreadyExists}
                        onChange={(event) => setContractorEmail(event.target.value)}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextFieldLabel
                        labelVariant='body1Bold'
                        label='Website URL:'
                        placeholder='https://www.contractor-website.com'
                        value={websiteUrl}
                        helperText={showWarnings && isEmpty(websiteUrl) ? 'Should add Website URL' : websiteUrl && !isValidUrl(websiteUrl) ? 'Should add a valid Website URL' : ''}
                        error={showWarnings && isEmpty(websiteUrl) || Boolean(websiteUrl && !isValidUrl(websiteUrl))}
                        onChange={(event) => setWebsiteUrl(event.target.value)}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextFieldLabel
                        labelVariant='body1Bold'
                        label='DocuSign Link:'
                        placeholder='https://www.contractor-docusign.com'
                        value={docuSignLink}
                        helperText={showWarnings && docuSignLink && !isValidUrl(docuSignLink) ? 'Should add a valid DocuSign Link' : ''}
                        error={Boolean(showWarnings && docuSignLink && !isValidUrl(docuSignLink))}
                        onChange={(event) => setDocuSignLink(event.target.value)}
                    />
                </Grid>
                <Grid item xs={6}>
                    <Typography
                        variant='body1'
                        fontWeight='bold'
                        color='infoText'
                    >
                        Once created, you can activate and assign territories to the contractor.
                    </Typography>
                </Grid>
                {/* <Grid item xs={6}>
                    <SelectInput
                        options={territories}
                        label='Territory'
                        onChange={handleChangeTerritory}
                    />
                </Grid> */}
                <Grid item xs={12}>
                    {/* <FormControlLabel
                        control={
                            <Checkbox
                                checked={active}
                                onChange={(event) => setActive(event.target.checked)}
                                name='active'
                                color='infoText'
                            />
                        }
                        label={<Typography>Active</Typography>}
                    /> */}
                </Grid>
                <Grid item xs={6}>
                    <Button
                        variant='containedLight'
                        fullWidth
                        onClick={handleCancel}
                    >
                        Cancel
                    </Button>
                </Grid>
                <Grid item xs={6}>
                    <Button
                        onClick={handleCreate}
                        variant='contained'
                        fullWidth
                        endIcon={<icons.Build />}>
                        Create Contractor
                    </Button>
                </Grid>
            </Grid>
        </PrivateLoader >
    )
}

export default AddContractor